// extracted by mini-css-extract-plugin
export default {"logo":"zWSLf","metaWrapper":"yS64E","meta":"rLjuA","ellipsis":"hEIN0","buttonContainer":"L4x6e"};